import { ScrollBar } from "../scroll-bar";
import styles from "./select-panel.module.scss";
import type { SelectPanelScrollBarViewProps } from "./types-select-panel-scroll-bar";

export function SelectPanelScrollBarView({
  overlayRef,
  scrollerRef,
  hasScroller,
}: SelectPanelScrollBarViewProps) {
  return (
    <div ref={overlayRef} className={styles.overlay}>
      {hasScroller && <ScrollBar.Root scrollerRef={scrollerRef} />}
    </div>
  );
}
